import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Inject,
  Injectable,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GTMScriptService {
  private renderer: Renderer2;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  
  pushStructured(data: Object): void {
    try {
      this.removeStructured();
      
      let node = this.renderer.createElement('script');
      node.type = 'application/ld+json';
      node.id = 'gtm-script';
      node.text = JSON.stringify([data]);
      this.renderer.appendChild(this.document.head, node);
    } catch (error) {
      console.error('GTM structured data eklenirken hata:', error);
    }
  }
  
  pushMultipleStructured(dataArray: Object[]): void {
    try {
      this.removeStructured();
      let node = this.renderer.createElement('script');
      node.type = 'application/ld+json';
      node.id = 'gtm-script';
      node.text = JSON.stringify(dataArray);
      this.renderer.appendChild(this.document.head, node);
    } catch (error) {
      console.error('GTM multiple structured data eklenirken hata:', error);
    }
  }
  
  removeStructured() {
    try {
      if (this.document.getElementById('gtm-script')) {
        this.renderer.removeChild(
          this.document.getElementsByTagName('head')[0],
          this.document.getElementById('gtm-script'),
          true
        );
      }
    } catch (error) {
      console.error('GTM structured data kaldırılırken hata:', error);
    }
  }
}
